import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  getTrends,
  joinHashtag,
  leaveHashtag,
} from "../../redux/actions/postActions";
import { getHashtagMetadata } from "../../utils/hashtagMetadata";
import { IonCard, IonIcon, useIonRouter } from "@ionic/react";
import { chevronForward, people, peopleOutline } from "ionicons/icons";
import "./CommunitiesList.css";
import CommunityStats from "../card/TrendsCard/CommunityStats";

const CommunitiesList = () => {
  const dispatch = useDispatch();
  const router = useIonRouter();
  const { trends } = useSelector((state) => state.post);
  const { data: currentProfile } = useSelector((state) => state.currentProfile);

  useEffect(() => {
    dispatch(getTrends());
  }, [dispatch]);

  const handleCommunityClick = (tag) => {
    router.push(`/hashtag/${tag}`);
  };

  const handlePostClick = (e, tag) => {
    e.stopPropagation();
    router.push(`/new-post${`?post=${encodeURIComponent(`#${tag}`)}`}`);
  };

  const handleJoin = (e, tag) => {
    e.stopPropagation();
    dispatch(joinHashtag(tag)).then(() => {
      dispatch(getTrends());
    });
  };
  const handleLeave = (e, tag) => {
    e.stopPropagation();
    dispatch(leaveHashtag(tag)).then(() => {
      dispatch(getTrends());
    });
  };
  if (!trends || trends.length === 0) {
    return null;
  }

  return (
    <div className="communities-list-container">
      <div className="communities-list-header">
        <div className="communities-list-header-title">
          <IonIcon
            size={5}
            color="black"
            icon={people}
            style={{
              fontSize: "1.1rem",
              transform: "translateY(-1px)", // Wrap the value in quotes
            }}
          />
          <span>Loon Communities</span>
        </div>

        <Link to="/trending" className="communities-list-header-link">
          <span>See all</span>
          <IonIcon icon={chevronForward} />
        </Link>
      </div>
      <div className="communities-list-scroll">
        {trends.map((trend, idx) => {
          const tag = trend.tag?.slice(1); // remove #
          const { title: displayName, banner } = getHashtagMetadata(
            tag,
            trend.hashtag,
          );
          const isOwner =
            currentProfile?._id &&
            trend.hashtag?.owner &&
            currentProfile._id.toString() === trend.hashtag.owner.toString();

          const isMember =
            trend?.hashtag?.members?.some(
              (member) =>
                member.toString() === currentProfile?._id?.toString() ||
                (member._id &&
                  member._id.toString() === currentProfile?._id?.toString()),
            ) || false;

          return (
            <IonCard
              key={idx}
              className="community-card ion-no-margin ion-shadow-md"
              onClick={() => handleCommunityClick(tag)}
            >
              {/* Banner */}
              <div className="community-card-banner">
                {banner ? (
                  <img src={banner} alt={displayName} />
                ) : (
                  <div className="community-card-banner-placeholder" />
                )}
              </div>

              {/* Info */}
              <div className="community-card-info">
                <h3 className="community-card-title">{displayName}</h3>
                <CommunityStats
                  postCount={trend.count}
                  memberCount={trend.userCount}
                  columns
                  hidePostsNumber
                />
                {trend?.hashtag?.name && !isOwner ? (
                  <button
                    className="community-card-cta"
                    onClick={
                      isMember
                        ? (e) => handleLeave(e, tag)
                        : (e) => handleJoin(e, tag)
                    }
                  >
                    {isMember ? "Joined" : "Join"}
                  </button>
                ) : (
                  <button
                    className="community-card-cta"
                    onClick={(e) => handlePostClick(e, tag)}
                  >
                    Post
                  </button>
                )}
              </div>
            </IonCard>
          );
        })}
      </div>
    </div>
  );
};

export default CommunitiesList;
